import { render } from "./refund-motive-selection-popup.vue?vue&type=template&id=049f3ee2"
import script from "./refund-motive-selection-popup.vue?vue&type=script&lang=js"
export * from "./refund-motive-selection-popup.vue?vue&type=script&lang=js"
script.render = render

export default script